/**
 * @generated SignedSource<<15c57be1562ba7d24900b007c6b30053>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateEpisodeInput = {
  chapters?: ReadonlyArray<ChapterInput> | null | undefined;
  episodeId: string;
  sourceLinks?: ReadonlyArray<string> | null | undefined;
  summary?: string | null | undefined;
  title?: string | null | undefined;
  topicSlug: string;
  transcript?: string | null | undefined;
};
export type ChapterInput = {
  description?: string | null | undefined;
  endTimeMs: number;
  id: string;
  startTimeMs: number;
  title: string;
};
export type EpisodeDetailPageUpdateMutation$variables = {
  input: UpdateEpisodeInput;
};
export type EpisodeDetailPageUpdateMutation$data = {
  readonly updateEpisode: {
    readonly episode: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"EpisodeDetailPage_episode">;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly code: string | null | undefined;
      readonly field: string | null | undefined;
      readonly message: string;
    }>;
  };
};
export type EpisodeDetailPageUpdateMutation = {
  response: EpisodeDetailPageUpdateMutation$data;
  variables: EpisodeDetailPageUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "UserError",
  "kind": "LinkedField",
  "name": "userErrors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "field",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EpisodeDetailPageUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateEpisodePayload",
        "kind": "LinkedField",
        "name": "updateEpisode",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Episode",
            "kind": "LinkedField",
            "name": "episode",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EpisodeDetailPage_episode"
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "MutationRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EpisodeDetailPageUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateEpisodePayload",
        "kind": "LinkedField",
        "name": "updateEpisode",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Episode",
            "kind": "LinkedField",
            "name": "episode",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "episodeId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "topicSlug",
                "storageKey": null
              },
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "summary",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "transcript",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "publishedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "durationSeconds",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "audioS3Key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sourceLinks",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Chapter",
                "kind": "LinkedField",
                "name": "chapters",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startTimeMs",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endTimeMs",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cc71ebb47d0a66515cd50e4802002e7f",
    "id": null,
    "metadata": {},
    "name": "EpisodeDetailPageUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation EpisodeDetailPageUpdateMutation(\n  $input: UpdateEpisodeInput!\n) {\n  updateEpisode(input: $input) {\n    episode {\n      id\n      ...EpisodeDetailPage_episode\n    }\n    userErrors {\n      field\n      message\n      code\n    }\n  }\n}\n\nfragment EpisodeDetailPage_episode on Episode {\n  id\n  episodeId\n  topicSlug\n  title\n  summary\n  transcript\n  publishedAt\n  durationSeconds\n  audioS3Key\n  sourceLinks\n  chapters {\n    id\n    title\n    startTimeMs\n    endTimeMs\n    description\n  }\n}\n"
  }
};
})();

(node as any).hash = "3dbb563ed7bf4bab1f75ffffe91dd4f5";

export default node;
